// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"688c4b49deaa1e1e60cf","5338":"eb76d39fec67eb47bb6f"}[chunkId] + ".js";
};